module.exports = __webpack_public_path__ + "static/dependenciesscreenshot-026d9c21fd29af3840e235e8c42fcc89.png";